module.exports = __webpack_public_path__ + "img/video.b253377f.svg";